module.exports = __webpack_public_path__ + "bg-footer-right.png?3eda37a3e7e334262b81c9e899d24d44";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-footer-right.png
// module id = 239
// module chunks = 0